module.exports = __webpack_public_path__ + "static/img/guolv.ab8e1ffa.png";